import { useEffect, useState } from 'react';
import { getDefaultBlogDesign } from '@/configs/defaultBlogDesign';

import { getDesignAPI } from '@/api/designs';
import BlogDisplay from '@/components/Shared/BlogDisplay';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { useTheme } from '@/features/theme';

function BlogDisplayContainer({ profile }) {
  const { mode } = useTheme();
  const [design, setDesign] = useState(() => getDefaultBlogDesign(mode));
  const designId = (profile.settings || {}).currentDesign;
  const [token] = useTokenState();

  useEffect(() => {
    const loadDesign = async () => {
      if (designId && designId !== '0') {
        const res = await getDesignAPI({
          designId,
          profileId: profile.id,
          token
        });
        if (!res.error) {
          setDesign({ ...res.data, id: designId });
          return;
        }
      }
      setDesign(getDefaultBlogDesign(mode));
    };
    loadDesign();
  }, [designId, profile.id, token, mode]);

  return <BlogDisplay profile={profile} design={design} />;
}

export default BlogDisplayContainer;
